import { TextField } from 'components/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import Form from 'components/filter/from';
import BucketSelect from 'components/form/bucket_select';

const FilterForm = ({ initialValues, defaultValues, processing, onSubmit, onClose }) => {
  const intl = useIntl();

  return (
    <Form
      header={<FormattedMessage id="header.place.filter" />}
      processing={processing}
      onClose={onClose}
      initialValues={initialValues}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      contentRenderer={(formik) => (
        <>
          <TextField
            fullWidth
            autoFocus
            margin="dense"
            id="name"
            name="name"
            label={intl.formatMessage({ id: 'name' })}
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
          />
          <BucketSelect
            margin="dense"
            id="bucket"
            name="bucket"
            label={intl.formatMessage({ id: 'filter.bucket' })}
            value={formik.values.bucket}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.bucket && Boolean(formik.errors.bucket)) || undefined}
          />
        </>
      )}
    />
  );
};

export default FilterForm;
